import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal fade show",
  style: {"display":"block"}
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header bg-accent text-white" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h6", { class: "modal-title" }, "Pilihan Lainnya", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "modal-body py-4" }
const _hoisted_10 = { class: "row flex-nowrap mx-n1" }
const _hoisted_11 = { class: "col-4 px-1" }
const _hoisted_12 = {
  key: 0,
  class: "col-4 px-1"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-success btn-block py-3",
  id: "chooseEdc",
  "data-toggle": "modal",
  "data-dismiss": "modal"
}, "Print Bill", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "col-4 px-1"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-success btn-block py-3",
  id: "chooseEdc",
  "data-toggle": "modal",
  "data-dismiss": "modal"
}, "Lost Bill", -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "row mt-3" }, null, -1)
const _hoisted_19 = {
  key: 0,
  class: "row flex-nowrap mx-n1"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 px-1" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-warning btn-block py-3",
    "data-toggle": "modal",
    "data-dismiss": "modal"
  }, "Gratis")
], -1)
const _hoisted_21 = [
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.modalVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideModal && _ctx.hideModal(...args))),
                "aria-label": "Close"
              }, _hoisted_8)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("button", {
                    class: "btn btn-primary btn-block py-3",
                    "data-toggle": "modal",
                    "data-dismiss": "modal",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onVoucherClick && _ctx.onVoucherClick(...args)))
                  }, "KPP/Voucher")
                ]),
                false
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
                  : _createCommentVNode("", true),
                false
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_18,
              false
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}